import FadeSlide from '@/components/common/FadeSlide';
import { AnalyticsPage, Channel, EnvInfo } from '@/types/analytics';
import { Box, Button, MenuItem, Select, Stack } from '@mui/material';
import { FC, useState } from 'react';
import ChannelInfo from '../callList/ChannelInfo';

type AnalyticsHeaderProps = {
  envInfo?: EnvInfo;
  channels: Channel[];
  selectedPage: AnalyticsPage;
  onSelect: (newPage: AnalyticsPage) => void;
};

const AnalyticsHeader: FC<AnalyticsHeaderProps> = ({ envInfo, channels, selectedPage, onSelect }) => {
  const [copySuccessful, setCopySuccessful] = useState<boolean>(false);
  const [open, setOpen] = useState<boolean>(false);

  const isSelected = (value: string) => selectedPage === value;

  const handleClose = (value?: string | number) => {
    navigator.clipboard.writeText(value?.toString() ?? '');
    setCopySuccessful(true);
  };

  return (
    <Stack direction='row' alignItems='center' pl={1} pr={2} borderBottom={2}>
      <Box display={'flex'}>
        <Button
          color='inherit'
          onClick={() => onSelect('Session Flow')}
          sx={{ opacity: isSelected('Session Flow') ? '50%' : '100%' }}
        >
          Session Flow
        </Button>
        <Button
          color='inherit'
          onClick={() => onSelect('App Log')}
          sx={{ ml: 2, opacity: isSelected('App Log') ? '50%' : '100%' }}
        >
          App Log
        </Button>
        <Button
          color='inherit'
          onClick={() => onSelect('Database Log')}
          sx={{ ml: 2, opacity: isSelected('Database Log') ? '50%' : '100%' }}
        >
          Database Log
        </Button>
        <Button
          color='inherit'
          onClick={() => onSelect('Prompts Log')}
          sx={{ ml: 2, opacity: isSelected('Prompts Log') ? '50%' : '100%' }}
        >
          Prompts Log
        </Button>
        <Button color='inherit' onClick={() => setOpen(true)} sx={{ ml: 2 }}>
          Channels
        </Button>
        {envInfo && (
          <Select
            value=''
            displayEmpty
            renderValue={() => `UUID: ${envInfo?.uuid}`}
            onChange={(e) => handleClose(e.target.value)}
            size='small'
            sx={{ ml: 2 }}
          >
            <MenuItem value={envInfo.uuid}>
              <Box fontWeight='bold' mr={1}>
                UUID:
              </Box>
              {envInfo.uuid}
            </MenuItem>
            <MenuItem value={envInfo.session}>
              <Box fontWeight='bold' mr={1}>
                Session:
              </Box>
              {envInfo.session}
            </MenuItem>
            <MenuItem value={envInfo.appname}>
              <Box fontWeight='bold' mr={1}>
                Appname:
              </Box>
              {envInfo.appname}
            </MenuItem>
            <MenuItem value={envInfo.hostname}>
              <Box fontWeight='bold' mr={1}>
                Host:
              </Box>
              {envInfo.hostname}
            </MenuItem>
            <MenuItem value={envInfo.environment}>
              <Box fontWeight='bold' mr={1}>
                Environment:
              </Box>
              {envInfo.environment}
            </MenuItem>
            {envInfo.starttime && (selectedPage === 'Session Flow' || selectedPage === 'Prompts Log') && (
              <MenuItem value={envInfo.starttime}>
                <Box fontWeight='bold' mr={1}>
                  Call start:
                </Box>
                {envInfo.starttime}
              </MenuItem>
            )}
          </Select>
        )}
      </Box>
      {copySuccessful && (
        <Stack
          position='absolute'
          top={0}
          width='100%'
          height='100%'
          justifyContent='start'
          alignItems='center'
          sx={{ pointerEvents: 'none' }}
        >
          <FadeSlide message={`Copied value to clipboard!`} onDone={() => setCopySuccessful(false)} />
        </Stack>
      )}
      {open && <ChannelInfo channels={channels || []} onClose={() => setOpen(false)} />}
    </Stack>
  );
};

export default AnalyticsHeader;
